module.exports = __webpack_public_path__ + "static/media/bowtie_logo_white.f9e607ea.png";